import React, {useMemo} from 'react'
import {permissionCodes} from 'modules/permissions/contants'
import {createCheckPermissions} from 'views/AppLocals/factory/createCheckPermissions'
import {organizationSettings} from 'views/AppLocals/Organization/Settings/OrganizationSettings'
import {Queries} from 'views/Shared/enums/Queries'
import {useMenuHandler} from 'views/Shared/handlers/useMenuHandler'
import UnderDevelopment from '../../Shared/components/UnderDevelopment'
import OrganizationSettingRoles from '../Role/OrganizationSettingRoles'
import OrganizationPermissionMatrix from '../Role/OrganizationPermissionMatrix'
import OrganizationLabelSettings from './OrganizationLabelSettings'

const EXTRA_ROUTES = [
    {key: 'entity-role', component: createCheckPermissions([permissionCodes.canEdit])(OrganizationSettingRoles)},
    {
        key: 'permission-role',
        component: createCheckPermissions([permissionCodes.canEdit])(OrganizationPermissionMatrix)
    },
    {key: 'terminology', component: OrganizationLabelSettings},
    ...['feature-toggle', 'system-logs', 'data-backup']
        .map(key => ({key, component: UnderDevelopment})),
].map(({key, component}) => ({key, path: key, component}))

const WorkspaceSettingContent = () => {
    const {menuItems, routeEntities: baseRoutes} = organizationSettings
    const routeEntities = useMemo(() => [...baseRoutes, ...EXTRA_ROUTES], [baseRoutes])

    const {activeKey, Component, onMenuSelect} = useMenuHandler({
        actionName: Queries.REL,
        routes: routeEntities,
    })

    return (
        <div className="px-3 space-y-3">
            <Component/>
            <div className="h-16"/>
        </div>
    )
}

export default WorkspaceSettingContent
